import { Component, OnInit } from '@angular/core';
import { CategoryPopupComponent } from '../category-popup/category-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { PageEvent } from '@angular/material/paginator';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {
  CasteCategorySearchForm: FormGroup;
  dialogRef: MatDialogRef<any>;
  casteCategoryList: any[];
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  setIntervalSearch: any;
  constructor(private dialog: MatDialog,
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.getCasteCategoryData();
    this.CasteCategorySearchForm = this.fb.group({
      SearchString: new FormControl('')
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getCasteCategoryData();
    this.keypress();
  }

  getCasteCategoryData() {
    // this.spinner.show();
    const payload = {};
    // payload['SearchString'] = ''
    // payload['CdCode'] = '',
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    this.umsService.getCasteCategoryData(payload).subscribe(res => {
      // this.spinner.hide();
      this.casteCategoryList = res.data;
      this.totalItems = res.data[0].TotalRecords;
    }, (ERROR: HttpErrorResponse) => {
      this.casteCategoryList = [];
      let data = {}
      // this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.casteCategoryList = [];
      let payload = {}
      payload['SearchString'] = this.CasteCategorySearchForm.value['SearchString'];
      payload['PageSize'] = this.pageSize;
      // payload['PageNumber'] = this.currentPage;
      if (payload['SearchString'] === "") {
        payload['PageNumber'] = this.currentPage;
      } else {
        payload['PageNumber'] = 1;
      }
      this.umsService.getCasteCategoryData(payload).subscribe(res => {
        if(res.status){
          this.casteCategoryList = res.data;
          this.totalItems = res.data[0].TotalRecords;
        }
        else{
          this.casteCategoryList = [];
          this.totalItems = 0;
        }
       
      }, (ERROR: HttpErrorResponse) => {
        this.casteCategoryList = [];
      });
    },1000)
   
  }

  addnewrecord() {

    const dialogRef = this.dialog.open(CategoryPopupComponent, {
      width: '75vh',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCasteCategoryData();
      this.CasteCategorySearchForm.controls['SearchString'].setValue('');
    });
  }

  editData(k) {
    const dialogRef = this.dialog.open(CategoryPopupComponent, {
      width: '75vh',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCasteCategoryData();
      this.CasteCategorySearchForm.controls['SearchString'].setValue('');
    });
  }

  deleteData(k) {
    const dialogRef = this.dialog.open(CategoryPopupComponent, {
      width: '75vh',
      data: { selected: k, key: "Delete" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCasteCategoryData();
      this.CasteCategorySearchForm.controls['SearchString'].setValue('');
    });
  }
}
